import { Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANDING_CONTENT } from "../content";
import { PhotoSlot } from "./PhotoSlot";
import { Reveal } from "./Reveal";
import { Section, SectionHeading, SectionLead } from "./Section";

// Real customer photos (UGC) — the strongest trust signal (PowerReviews), and the
// one thing we must NOT fabricate. Empty at launch: it shows an honest empty state
// (a few placeholder tiles + an invitation), filled from real orders later. The
// photographer/author brief explains the sourcing rule in-context.
export function UgcGallery() {
  const { t } = useTranslation("landing");
  const { photos } = LANDING_CONTENT.ugc;
  const isEmpty = photos.length === 0;

  return (
    <Section id="ugc" labelledBy="ugc-heading" className="bg-paper">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <SectionHeading id="ugc-heading">{t("ugc.heading")}</SectionHeading>
          <SectionLead className="mt-4">{isEmpty ? t("ugc.emptyLead") : t("ugc.lead")}</SectionLead>
        </div>
      </Reveal>

      <Reveal delayMs={80} className="mt-10">
        <ul className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {isEmpty
            ? [0, 1, 2, 3].map((i) => (
                <li key={`ugc-slot-${i}`}>
                  <PhotoSlot
                    briefId={i === 0 ? "ugc" : undefined}
                    aspectClassName="aspect-square"
                    icon={Heart}
                    label={t("ugc.slotPlaceholder")}
                  />
                </li>
              ))
            : photos.map((photo) => (
                <li key={photo.src}>
                  <PhotoSlot
                    image={photo}
                    alt={t("ugc.photoAlt")}
                    aspectClassName="aspect-square"
                    icon={Heart}
                  />
                </li>
              ))}
        </ul>
      </Reveal>
    </Section>
  );
}
